import { useMutation } from '@tanstack/react-query';
import { POST, POST_CLAIM_CUT_OFF } from '../../../services';
import { openAlert } from '../../../components/alert/hooks';

export const useSubmitCutOff = ({ reset }) =>
  useMutation({
    mutationFn: async (payload) => {
      const response = await POST(POST_CLAIM_CUT_OFF(), payload);
      return response;
    },
    onSuccess: (data) => {
      openAlert({
        model: 'message',
        type: 'success',
        message: data?.message,
      });
      reset({
        ...data,
        itemCode: '',
      });
    },
    onError: (error) => {
      openAlert({
        model: 'message',
        type: 'error',
        message: error?.message,
      });
    },
  });
